// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Ioo1","bigColWidth":"Table_bigColWidth__env-u","biggerColWidth":"Table_biggerColWidth__3KQJY","row":"Table_row__2VH7b","col":"Table_col__3wHz0"};